export const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

// Supported signup countries (API country IDs)
export const SIGNUP_COUNTRY_IDS = {
  US: "233",
  NIGERIA: "161",
  INDIA: "251",
} as const;

export const SUPPORTED_SIGNUP_COUNTRY_IDS = new Set<string>([
  SIGNUP_COUNTRY_IDS.US,
  SIGNUP_COUNTRY_IDS.NIGERIA,
  SIGNUP_COUNTRY_IDS.INDIA,
]);

/** ISO 3166-1 alpha-2 code → API country ID */
export const ISO_TO_COUNTRY_ID: Record<string, string> = {
  us: SIGNUP_COUNTRY_IDS.US,
  ng: SIGNUP_COUNTRY_IDS.NIGERIA,
  in: SIGNUP_COUNTRY_IDS.INDIA,
};

export function isSignupCountrySupported(countryId: string): boolean {
  return SUPPORTED_SIGNUP_COUNTRY_IDS.has(countryId);
}
